/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * set flag
 * @export
 * @interface DriverFeedbackFlagSetResp
 */
export interface DriverFeedbackFlagSetResp {
    /**
     * flag was set
     * @type {boolean}
     * @memberof DriverFeedbackFlagSetResp
     */
    success?: boolean;
}

export function DriverFeedbackFlagSetRespFromJSON(json: any): DriverFeedbackFlagSetResp {
    return DriverFeedbackFlagSetRespFromJSONTyped(json, false);
}

export function DriverFeedbackFlagSetRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverFeedbackFlagSetResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function DriverFeedbackFlagSetRespToJSON(value?: DriverFeedbackFlagSetResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}


